import React, { useEffect, useState } from "react";
import { useToggleClick } from './Menu';
import logo from './logo.png';
import pin from './pin.png';
import zomato from './zomato.png';
import swiggy from './swiggy.png';
import dineout from './dineout.png';
import whatsapp from './whatsapp.png';
import { Helmet } from "react-helmet";

const Header = () => {
  const handleToggleClick = useToggleClick();
  const [logo, setLogo] = useState('');

  useEffect(() => {
    loadLogo();
 }, []);


 const loadLogo=()=>{
  fetch("https://foresttacafemenuapi.deepsciencetech.com/index.php/Api/logo", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    })
      .then((res) => res.json())
      .then((result) => {
        //console.log(result);
        if (result.data != "") {
          const data = result.data;
          setLogo(data);
        }
      })
    .catch((err) => {
      console.log(err.message);
    });
}

    return (
      <>
    <Helmet>

      <title>{logo.title}</title>
      <link id="favicon" rel="icon" href={logo.image} type="image/x-icon"/>
      <meta
        name="description"
        content="Discover the essence of The Forestta Cafe - where flavors come alive. Explore our menu for a culinary journey like no other. Indulge today!"
      />
      <meta
        name="keywords"
        content="The Forestta Cafe, Gurgaon"
      />

    </Helmet>       
    <header className="main_header" id="Header">
      <div className="main-header" style={{backgroundColor: logo.header_color || '#191F38'}}>
        <div className="container">
          <div className="bottom-header">
            <div className="logo-cont">
            <a href="/"> <img src={logo.image} alt="logo" /></a>
            </div>
            <ul className="main-menu">
              <li>
                <a href="/" style={{color: logo.header_text_color || '#ffffff'}}>Home</a>
              </li>
              <li>
                <a href="/menu" style={{color: logo.header_text_color || '#ffffff'}}>Menu</a>
              </li>
              {/* <li>
                <a href="https://feedback.haikutheasiankitchen.com" style={{color: logo.header_text_color || '#ffffff'}}>Feedback</a>
              </li> */}
            </ul>
            <div className="toogle-bar">
              <div id="toggleNav" onClick={handleToggleClick}>
                <span className="MenuBtn">
                  <i />
                  <i />
                  <i />
                </span>
              </div>
              <div id="megaMenu" className="menuNavigation" style={{}}>
                <div className="container">
                  <ul className="listItems">
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li>
                      <a href="/menu">Menu</a>
                    </li>
                    {/* <li>
                      <a href="https://feedback.haikutheasiankitchen.com">Feedback</a>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    {/* <div className="sticky-whatsapp">
      <a href="https://api.whatsapp.com/send?phone=917095876888"><img src={whatsapp} alt="whatsapp-icon"/></a>
    </div> */}
    </>
    );
  };
  export default Header;
